import { useDispatch } from "react-redux";
import { personById } from "../../../store/person/actions";
var useClientRecord = function (setShowNextDisabled, setDocumentType, setDocumentName, setDocumentNumber, documentNumber, setSeeToast, typeAlert, listIdentificationType, lsVariables, documentType, setOpenAlert) {
    var dispatch = useDispatch();
    var isValid = function () {
        var dt = documentType;
        var dn = documentNumber;
        listIdentificationType.find(function (item) {
            if (item.id === documentType) {
                dt = item.name;
            }
        });
        var type = dt;
        dt = dt.toLowerCase();
        dt = dt.replace(/é/g, "e");
        dn = dn.replace(/-/g, "");
        dn = dn.replace(/_/g, "");
        var vars = [
            {
                idType: documentType,
                docNumber: dn,
                type: type,
            },
        ];
        var result = (dt === "cedula" && (dn === null || dn === void 0 ? void 0 : dn.length) === 11) ||
            (dt === "pasaporte" && (dn === null || dn === void 0 ? void 0 : dn.length) > 3);
        lsVariables.setVariablesStored(vars);
        return result;
    };
    var handleChangeSelect = function (e, a) {
        setShowNextDisabled(true);
        setDocumentType(a[0].id);
        setDocumentName(a[0].name);
        setDocumentNumber("");
    };
    var validDocument = function (name, number) {
        var dt = name.toLowerCase();
        dt = dt.replace(/é/g, "e");
        var dn = number.replace(/-/g, "");
        dn = dn.replace(/_/g, "");
        return ((dt === "cedula" && (dn === null || dn === void 0 ? void 0 : dn.length) === 11) ||
            (dt === "pasaporte" && (dn === null || dn === void 0 ? void 0 : dn.length) > 3));
    };
    var handleChange = function (e, a) {
        setDocumentNumber(e);
        setShowNextDisabled(true);
    };
    var handleSearch = function () {
        setOpenAlert(false);
        var _term = documentNumber;
        var dt = "";
        listIdentificationType.find(function (item) {
            if (item.id === documentType) {
                dt = item.name;
            }
        });
        dt = dt.toLowerCase();
        dt = dt.replace(/é/g, "e");
        if (dt !== "pasaporte") {
            _term = _term.replace(/-/g, "");
            _term = _term.replace(/_/g, "");
        }
        if ((_term === null || _term === void 0 ? void 0 : _term.length) > 0) {
            dispatch(personById({
                document: _term,
                identificationTypeId: documentType,
            }));
        }
        else {
            setSeeToast({
                show: true,
                message: "¡Debe ingresar un documento válido!",
                type: typeAlert.info,
            });
        }
    };
    return {
        handleChangeSelect: handleChangeSelect,
        validDocument: validDocument,
        handleChange: handleChange,
        handleSearch: handleSearch,
        isValid: isValid,
    };
};
export default useClientRecord;
